import classnames from 'classnames';
import React, { Ref } from 'react';

import { Icon, IconTypes } from '@eika/icon';
import '@eika/input-style';

import Input, { InputProps } from './Input';
import InputLabel from './InputLabel';

export interface SearchInputProps extends InputProps {
    classNameInput?: string;
    hideIcon?: boolean;
}

const SearchInput = React.forwardRef(
    (
        { className, classNameInput, label, sublabel, type = 'search', hideIcon = false, ...rest }: SearchInputProps,
        ref: Ref<HTMLInputElement>,
    ): JSX.Element => {
        return (
            <InputLabel label={label} sublabel={sublabel}>
                <div className={classnames('sgw-search-input', className, { 'hide-icon': hideIcon })}>
                    {!hideIcon && (
                        <div className="sgw-search-input__icon-wrapper">
                            <Icon type={IconTypes.SOEK_24} className="icon--20 sgw-search-input__search-icon" />
                        </div>
                    )}
                    <Input className={classNameInput} type={type} {...rest} ref={ref} />
                </div>
            </InputLabel>
        );
    },
);

export default SearchInput;
